import { createContext } from 'react';

import type { XYChartSelectConfig } from '../types/xy-chart-props.js';

export const XYChartSelectConfigContext = createContext<
  XYChartSelectConfig | undefined
>(undefined);
